import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @file ClauseText.tsx
 * @description 查核條文 / 說明文字的富文字渲染（2026-09-25 回報序53–58，全部表單共用）。
 *
 * 解析規則見 ./clause-text（純函式）：
 *  - 星號標記統一顯示為紅色「（★★）」；
 *  - 帶（★★）的條文內容以黑色粗體顯示；
 *  - 換行 / 多個（★★）/ 連續 (1)(2)… 各自獨立成段（每段一個 block）。
 */
import { memo } from 'react';
import { hasStarMark, normalizeStarMarks, MUST_AUDIT_MARK, parseClauseText } from './clause-text';
/** 必查核標記顏色（紅） */
const MARK_COLOR = '#dc2626';
/** 必查核條文粗體文字顏色（黑） */
const BOLD_TEXT_COLOR = '#000000';
/**
 * 渲染一段條文文字：逐段輸出 block，（★★）標紅，粗體段落以黑色加粗。
 * 以 memo 包裹：條文文字來自 schema、引用穩定，填寫時不重新解析。
 */
export const ClauseText = memo(function ClauseText({ text, mustAudit, gap = 2 }) {
    const paragraphs = parseClauseText(text, { mustAudit });
    return (_jsx(_Fragment, { children: paragraphs.map((p, i) => (_jsx("div", { style: {
                marginTop: i === 0 ? 0 : gap,
                whiteSpace: 'pre-wrap',
                ...(p.bold ? { fontWeight: 700, color: BOLD_TEXT_COLOR } : null),
            }, children: p.segments.map((s, j) => s.mark ? (_jsx("span", { style: { color: MARK_COLOR, fontWeight: 700 }, "aria-label": "\u5FC5\u67E5\u6838\u91CD\u9EDE", children: s.text }, j)) : (_jsx("span", { children: s.text }, j))) }, i))) }));
});
/**
 * 欄位標籤（Form.Item label）用的行內渲染：含星號標記時把（★★）標紅，其餘文字原樣。
 * 不分段、不加粗（標籤空間有限）；不含星號時直接回傳原字串，對既有表單零影響。
 *
 * 例：查核表 checklist 欄位標籤「註：（★★）見證評鑑缺失之增修條文為必查核重點」（序53）。
 */
export function renderMarkedLabel(label) {
    if (!label || !hasStarMark(label))
        return label;
    const parts = normalizeStarMarks(label).split(MUST_AUDIT_MARK);
    return (_jsx("span", { children: parts.map((part, i) => (_jsxs("span", { children: [i > 0 && _jsx("span", { style: { color: MARK_COLOR, fontWeight: 700 }, children: MUST_AUDIT_MARK }), part] }, i))) }));
}
//# sourceMappingURL=ClauseText.js.map